import React from "react";
import { Route, Routes } from "react-router-dom";

import { RegisterAccount } from "./RegisterAccount/RegisterAccount";
import { Login } from "./Login/Login";
import { ForgotPassword } from "./ForgotPassword/ForgotPassword";

export function Auth() {
  return (
    <Routes>
      <Route path="register" element={<RegisterAccount />} />
      <Route path="login" element={<Login />} />
      <Route path="forgot-password" element={<ForgotPassword />} />
    </Routes>
  );
}
